export const mutations = {
  setIncome: function (state, ent) {
    var tmp = [...ent].map((d) => {
      d.CreatedAt = new Date(d.CreatedAt.substring(0,10));
      d.BankPaymentDate = new Date(d.BankPaymentDate.substring(0,10));
      return d;
    });
    state.income = tmp;
  },
  setApproved: function (state, data) {
    state.approved = data;
  },
  setCompany: function (state, data){
    state.company = data;
  },
  setentreaties: function (state, data){
    state.entreaties = data;
  }
};
